import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Table, Spin, DatePicker, Pagination, message, Breadcrumb, Space, Col, Row, Input, Button, Typography  } from "antd";
import moment from "moment";
import { getAllInvoicePayments } from "../../../actions/invoicepayments";

const { RangePicker } = DatePicker;
const { Title } = Typography;

const Payment = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [dateRange, setDateRange] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [isSearchTriggered, setIsSearchTriggered] = useState(false); // New state to track search trigger

  const fetchData = async (page = 1, pageSize = 10, dateRange = [], keyword = "") => {
    setLoading(true);
    try {
      const filters = {};

      if (dateRange.length === 2) {
        filters.start = moment(dateRange[0]).toISOString();
        filters.end = moment(dateRange[1]).toISOString();
      }

      const response = await dispatch(getAllInvoicePayments(page, pageSize, keyword, filters));
      if (response) {
        console.log(response);
        setData(response.results);
        setTotal(response.count);
      } else {
        setData([]);
        setTotal(0);
      }
    } catch (error) {
      message.error("Failed to fetch invoice payments.");
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    setIsSearchTriggered(true);
    fetchData(1, pageSize, dateRange, keyword);
    setCurrent(1);
  };

  const handleDateChange = (dates) => {
    setDateRange(dates);
  };

  const handleKeywordChange = (e) => {
    setKeyword(e.target.value);
  };

  const handlePageChange = (page, size) => {
    setCurrent(page);
    setPageSize(size);
    fetchData(page, size, dateRange, keyword);
  };

  const calculateTotals = (data) => {
    return data.reduce(
      (totals, item) => {
        const bill = parseFloat(item.bill) || 0;
        const discount = parseFloat(item.discount) || 0;
        const payment = parseFloat(item.payment) || 0;

        totals.totalBill += bill + discount;
        totals.totalPayment += payment;
        totals.totalDiscount += discount;

        return totals;
      },
      { totalBill: 0, totalPayment: 0, totalDiscount: 0 }
    );
  };

  const { totalBill, totalPayment, totalDiscount } = calculateTotals(data);

  const columns = [
    {
      title: "SL.",
      dataIndex: "index",
      key: "index",
      render: (text, record, index) => index + 1,
  },
    {
      title: "Invoice Number",
      dataIndex: ["Invoice", "invoice_number"],
      key: "invoice_number",
    },
    {
      title: "Location",
      dataIndex: ["Invoice", "Location_name"],
      key: "Location_name",
    },
    {
      title: "Total Bill",
      dataIndex: "bill",
      key: "bill",
      render: (_, record) => {
        const bill = parseFloat(record.bill) || 0;
        const discount = parseFloat(record.discount) || 0;
        return `${bill + discount}`;
      },
    },
    {
      title: "Discount",
      dataIndex: "discount",
      key: "discount",
      render: (value) => `${value}`,
    },
    {
      title: "Payment",
      dataIndex: "payment",
      key: "payment",
      render: (value) => `${value}`,
    },
    // {
    //   title: "Tax",
    //   dataIndex: "tax",
    //   key: "tax",
    //   render: (value) => `${value}`,
    // },
    {
      title: "Payment Date",
      dataIndex: "issue_date",
      key: "issue_date",
      render: (value) => moment(value).format("YYYY-MM-DD"),
    },
    {
      title: "Issued Date",
      dataIndex: ["Invoice", "issue_date"],
      key: "issue_date",
      render: (value) => moment(value).format("YYYY-MM-DD"),
    },
  ];

  return (
    <div>
      <Breadcrumb style={{ marginBottom: 16 }}>
        <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
        <Breadcrumb.Item>Payments</Breadcrumb.Item>
      </Breadcrumb>
      <div className="site-layout-background main-frame">
        <Space style={{ marginBottom: 16 }}>
          <Row wrap={false} gutter={16}>
            <Col>
              <h3>Keyword Search</h3>
              <Input
                placeholder="Search by keyword"
                value={keyword}
                onChange={handleKeywordChange}
              />
            </Col>
            <Col>
              <h3>Issue Date</h3>
              <RangePicker onChange={handleDateChange} />
            </Col>
            <Col>
            <h3 style={{color:"white"}}>.</h3>
              <Button
                type="primary"
                // style={{ marginTop: 24 }}
                onClick={handleSearch}
              >
                Search
              </Button>
            </Col>
          </Row>
        </Space>
      </div>
      <div style={{
          marginTop: 16,
          marginRight: "20px",
          textAlign: "right",
          display: "flex",
          justifyContent: "space-between", 
          gap: "5px", 
        }}
      >
        <p><b>Total Available Bill: {totalBill.toFixed(2)}</b></p>
        <p><b>Total Cash Received: {totalPayment.toFixed(2)}</b></p>
        <p><b>Total Discount: {totalDiscount.toFixed(2)}</b></p>
      </div>
      <Spin spinning={loading}>
        <Table
          columns={columns}
          dataSource={isSearchTriggered ? data : []} 
          rowKey={(record) => record.id}
          pagination={false}
          bordered
          locale={{ emptyText: "No data available. Please use search." }}
        />
      </Spin>
      {/* <div style={{ marginTop: 16, textAlign: "right" }}>
        <Title level={5}>Total Bill: {totalBill.toFixed(2)}</Title>
        <Title level={5}>Total Payment: {totalPayment.toFixed(2)}</Title>
      </div> */}
      <Pagination
        current={current}
        pageSize={pageSize}
        total={total}
        showSizeChanger
        onChange={handlePageChange}
        onShowSizeChange={handlePageChange}
        style={{ marginTop: 16, textAlign: "right" }}
      />
    </div>
  );
};

export default Payment;
